import { useQuery } from '@gogame/query';

import { filtersKey } from './queryKeyFactory';

export const useQueryListData = ({
  screen,
  name,
  source,
  dependsParams,
  value,
  searchQuery,
  onError,
  onStartLoad,
  onEndLoad,
  enabled = false,
  serverSideSearch,
}) => {
  const filterKey = filtersKey.query(name);
  const queryKey = [
    screen,
    ...filterKey.entityKey,
    { ...dependsParams, searchQuery, ids: value },
  ];
  const queryFn = async (_, { signal }) => {
    onStartLoad && onStartLoad();

    let params = {
      ...dependsParams,
    };

    if (serverSideSearch) {
      if (searchQuery?.length) {
        params.query = searchQuery;
      } else {
        if (value) {
          params.selectedIds = value;
        }
      }
    }

    const result = await source(params, signal);

    onEndLoad && onEndLoad(result);

    return result;
  };

  const { data, isLoading, isRefetching, refetch, error, isFetched } = useQuery(
    queryKey,
    queryFn,
    {
      enabled: enabled,
      disabledErrorMessage: true,
      keepPreviousData: true,
      onError,
      onSuccess: () => {
        onError(null);
      },
    }
  );
  return { data, isLoading, isRefetching, refetch, error, isFetched };
};
